/**
 *
 * @param array The array to sort alphabetically
 * @param key The key used to compare values of objects
 * @returns The array sorted alphabetically
 * @example sortAlphabetically([{ id: 'id2', text: 'valueB' }, { id: 'id1', text: 'valueA' }], 'text')
 */
export const sortAlphabetically = <T extends string, U extends { [K in T]?: string | null }>(
  array: U[],
  key: T
): U[] => {
  return array.sort((value1, value2) => {
    // Translations are not guaranteed for every locale (e.g. ja before it is
    // translated), so fall back to an empty string for a stable comparison.
    const value1Translation = value1[key] ?? '';
    const value2Translation = value2[key] ?? '';

    return value1Translation.localeCompare(value2Translation);
  });
};
